import { render, staticRenderFns } from "./extent-field.vue?vue&type=template&id=12299230"
import script from "./extent-field.vue?vue&type=script&lang=js"
export * from "./extent-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports